const fetchUserDetails = async (): Promise<{
	name: string;
	email: string;
	iconUrl?: string;
	isPremiumUser: boolean;
}> => {
	return {
		name: "",
		email: "",
		isPremiumUser: false,
	};
};

export default fetchUserDetails;
